import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";

import { StringValue } from "./StringValue";
import { StringMap } from "./StringMap";
import { getTroopNameFromId, getAbbreviatedNumber } from "Utils/Common";

export default function(props) {
  const { task } = props;
  logger.log("task", task);
  const [showDetail, setShowDetail] = React.useState(
    task.taskstatusdetail.showdetail || false
  );

  return (
    <TaskletCard title="World Boss">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Selected Boss"}
          value={task.taskstatusdetail.selectedworldboss.eventname}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Selected Hero"}
          value={task.taskstatusdetail.selectedhero.heroname}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Pop Runes"}
          value={task.taskstatusdetail.poprunes}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Pop Runes Mins"}
          value={task.taskstatusdetail.poprunesmins}
          valueParser={(v) => <>{v}</>}
        />
        <StringValue
          label={"Mith Hit"}
          value={task.taskstatusdetail.mithhits}
          valueParser={(v) => <>{v}</>}
        />
        <StringMap
          label={"Troops to send"}
          valueMap={task.taskstatusdetail.troops}
          valueParser={(k, v) => (
            <>
              {getTroopNameFromId(k)}: {v}
            </>
          )}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Hits Done"}
          value={
            <>
              {task.taskstatusdetail.totalhitsdone}/
              {task.taskstatusdetail.noOfHits}
            </>
          }
          valueParser={(v) => <>{v}</>}
        />
        {showDetail && (
          <div>
            <div
              className="infokey enlargeonhover"
              style={{ fontSize: "15px" }}
              onClick={() => setShowDetail(false)}
            >
              Score Legend (Click To Collapse)
            </div>
            {task.taskstatusdetail.scorelegend &&
              task.taskstatusdetail.scorelegend.map((item) => {
                return (
                  <div className="infovalue" style={{ fontSize: "10px" }}>
                    {item.hitno} :{getAbbreviatedNumber(item.score)}
                  </div>
                );
              })}
          </div>
        )}
        {!showDetail && (
          <div>
            <div
              className="infokey enlargeonhover"
              style={{ fontSize: "15px" }}
              onClick={() => setShowDetail(true)}
            >
              Score Legend (Click For Details)
            </div>
            <div className="infovalue" style={{ fontSize: "10px" }}>
              Total Score :
              {getAbbreviatedNumber(task.taskstatusdetail.totalscore)}
            </div>
          </div>
        )}
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
